// @ts-expect-error legacy code
import {getBaselineComparison, renderBaselineComparison} from "@/pages/rum/v2/RumUtils.jsx";

import "./RUMBaselineComparsion.css";

interface RUMBaselineComparisonProps {
  feature: {
    deltaPct: number;
  };
  rowData: unknown;
}

export const RUMBaselineComparison = ({feature, rowData}: RUMBaselineComparisonProps) => {
  const comparison = getBaselineComparison(feature, rowData);
  if (!comparison) {
    return "--";
  }
  return renderBaselineComparison(comparison, {subLabel: comparison.subLabel});
};
